import alt from 'alt'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { GlobalErrorActions } from 'actions'

@createStore(alt)
export default class GlobalErrorStore {
  constructor() {
    this.state = { globalError: null }

    this.bindActions(GlobalErrorActions);
  }
  
  static displayName = 'GlobalErrorStore'

  setGlobalError(globalError) {
    this.setState({ globalError })
  }

  clearGlobalErrors() {
    this.setState({ globalError: null })
  }
}



// WEBPACK FOOTER //
// ./app/stores/GlobalErrorStore.js